<div class="doc-upload-actions" *ngIf="!showCapture && showBackButton">
    <button mat-button class="secondary" (click)="return()">Back to Documents</button>
</div>

<div class="upload-card" [ngClass]="{ hidden: !showBegin }">
    <mat-card>
        <div class="upload-card-body">
            <h2>{{ pageTitle }}</h2>
            <p>
                Place your ID face-up on a flat surface. Using a well-lit area and dark background, take a photo of your ID, ensuring it takes up most of the
                frame while the text remains sharp and clear.
            </p>
            <div class="upload-card-actions pdf-column">
                <button class="mobile-view-btn" mat-button type="button" (click)="startImageCapture()">Take Photo</button>
                <input
                    #manualInput
                    type="file"
                    accept="image/*"
                    style="display: none"
                    capture="environment"
                    (change)="onImageCapture($event.target['files'][0])"
                />
            </div>
        </div>
    </mat-card>
</div>

<div [ngClass]="{ hidden: !showPreview }" class="single-upload-preview-wrapper">
    <div class="upload-actions">
        <button mat-button type="button" class="primary" (click)="continue()">Continue</button>
        <button class="secondary" mat-button type="button" (click)="recapture()">Retake</button>
    </div>
    <div class="single-upload-preview-image-wrapper">
        <canvas #uploadPreview id="barcodeUploadPreview"> </canvas>
    </div>
</div>
